import React from "react";
import PropTypes from "prop-types";

const ProfileHistoryActionDateFormatter = ({ row }) => {
  const dateStr = row.actionDateAsString.split(" ")[0];
  return <div title={row.actionDateAsString}>{dateStr}</div>;
};

ProfileHistoryActionDateFormatter.propTypes = {
  row: PropTypes.shape({
    actionDateAsString: PropTypes.string.isRequired
  }).isRequired
};

export default ProfileHistoryActionDateFormatter;
